import cart from './cart'
export default `mutation setEmailForGuest($input: SetGuestEmailOnCartInput) {
  setGuestEmailOnCart(input: $input) {
    cart { ${cart} }
   }
 }
`
